import { Component, OnInit } from '@angular/core';
import {SessionService} from '../../../services/session.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  public token;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public userService: SessionService
  ) {
    this.token = this.userService.getToken();
  }

  ngOnInit(): void {
    this.logout();
  }

  logout() {
    /*const event_log: EventsLog = {
      from_url: location.href,
      event: 'onClick',
      element: 'logoutBtn',
      action: 'logout'
    };

    this.route.params.subscribe(params => {
      // convertir a entero
      let logout = +params['sure'];
      if (logout == 1) {
        this.userService.saveLogoutEvent(event_log).subscribe(res => {

        });
        this.userService.removeToken();
      }
    });*/

    this.route.params.subscribe(params => {
      // convertir a entero
      let logout = +params['sure'];
      if (logout == 1) {
        this.userService.logout();
      }
    });
  }
}
